import { useEffect, useState } from 'react';
import { useUserDetailContext } from '../service/context/userDetailContext';
import { UnifiedOnboardingData } from '../pages/onboarding/onboarding.type';

export const useOnboarding = () => {
  const { userDetail } = useUserDetailContext();
  const [formData, setFormData] = useState<UnifiedOnboardingData>({
    firstName: '',
    lastName: '',
    email: '',
    profilePicture: null,
    profilePictureUrl: null,
    profilePictureBase64: null,
    fileName: null,
    signatureBase64: null,
  });

  useEffect(() => {
    if (userDetail) {
      setFormData((prev) => ({
        ...prev,
        firstName: userDetail.firstName ?? '',
        lastName: userDetail.lastName ?? '',
        email: userDetail.email ?? '',
      }));
    }
  }, [userDetail]);

  // Handle form field changes
  const handleChange = <K extends keyof UnifiedOnboardingData>(
    field: K,
    value: UnifiedOnboardingData[K],
  ) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return {
    formData,
    handleChange,
  };
};
